import React from "react";

const RADIUS = 15;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Compact reading-progress readout for the hub toolbar: a small ring plus
// "read / total" and the unread count.
const ProgressCard = ({ read, total }) => {
  const pct = total ? Math.round((read / total) * 100) : 0;
  const offset = CIRCUMFERENCE - (pct / 100) * CIRCUMFERENCE;

  return (
    <div className="flex items-center gap-2.5 flex-shrink-0" title={`${pct}% of articles read`}>
      <div className="relative flex-shrink-0 w-9 h-9">
        <svg viewBox="0 0 36 36" className="w-9 h-9 -rotate-90">
          <circle cx="18" cy="18" r={RADIUS} strokeWidth="3.5" fill="none" className="text-border" stroke="currentColor" />
          <circle
            cx="18"
            cy="18"
            r={RADIUS}
            strokeWidth="3.5"
            fill="none"
            strokeLinecap="round"
            className="text-primary"
            stroke="currentColor"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-[9.5px] font-bold text-text_primary">{pct}%</span>
        </div>
      </div>

      <div className="leading-tight whitespace-nowrap">
        <p className="text-[13px] text-text_muted">
          <span className="font-semibold text-text_primary">{read}</span> / {total} read
        </p>
        <p className="mt-0.5 text-[11px] text-text_muted">{total - read} unread</p>
      </div>
    </div>
  );
};

export default ProgressCard;
